<template>
  <section id="page-about-foobar">
    <div class="container">
      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>

      <div class="row">
        <div class="col-sm-12 content fb-bg-light">
          <h3>What's going on?</h3>
          <p>
            You might be asking who's wasting time on this and what's the point ...? So ...
          </p>

          <br><h4>Who?</h4>
          <p>
            <a href="mailto:jakub@foobar.beer" title="jakub@foobar.beer">jakub@foobar.beer</a>
          </p>

          <br><h4>Why?</h4>
          <p>
            It's simple really - during the past {{ new Date().getFullYear() - 2005 }}+ years I've been programming and playing around the ITverse
            and I discovered that I keep adding different foobars, whether it's foobars useful for security
            purposes, Java development, data analysis or some of my ml trainings, into several projects that keep
            growing beyond anything that could possibly be useful at this point.
          </p>
          <p>
            That's why I decided to create searchable, taggable library of these snippets and small complete solutions
            that can help me use the data that I have ready already and maybe even help other people with their awesome
            challenges getting through the stuff that I already went through.
          </p>

          <br><h4>So ... What?</h4>
          <p>
            Well ... You can find a collection of pretty much everything that I find interesting - my goal is to keep
            adding at least several Foobars every week and so far it's going quite ok (even though there is still some
            time that I should spend coding the site itself).
          </p>

          <br><h5>Topics Covered</h5>
          <ul>
            <li>Java</li>
            <li>Kotlin</li>
            <li>Freemarker</li>
            <li>SQL</li>
            <li>NoSQL (MongoDB, Hazelcast)</li>
            <li>Reverse engineering</li>
            <li>Locksport</li>
          </ul>

          <br><h4>Hit me up!</h4>
          <p>
            HMU with anything you want! I am up for adding your own snippets (the administration interface is not yet public).<br><br>
            And definitely let me know if some of my snippets actually helped you solve your problems!<br><br>
            You can reach me at <a href="mailto:jakub@foobar.beer" title="jakub@foobar.beer">jakub@foobar.beer</a> - I'll be looking forward on the other side!
          </p>
        </div>
      </div>

      <div class="row">
        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Clearfix from '@/components/utils/Clearfix'

  export default {
    components: { Clearfix }
  }
</script>

<style>
#page-about-foobar {
  background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
  background-size: cover;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// AboutFoobar.vue?3c9321e2